import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';
import languagesAPI from '../../controllers/languages';
import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('NO_DATA', LOG_LEVELS.DEBUG);

class noData extends Component {
  render() {
    const pageText = languagesAPI.format(this.props.languages, this.props.noDataText)
    return (
      <div className='no-data'>
      {this.props.loadingCount > 0 ? (
        <div></div>
      ) : (
        <div>
          <h2>{languagesAPI.format(this.props.languages, 'NoDataTitle', [pageText])}</h2>
          <p>{languagesAPI.format(this.props.languages, 'NoDataAdditional', [pageText])}</p>
        </div>
      ) }
      </div>
    );
  }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  const loadingCount = _.reduce(state, (count, subState) => {
    if (subState?.loading) {
      return count + 1;
    }
    return count;
  }, 0);
  return {
    loadingCount
  };
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(noData);